import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Row, Col, Label} from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, Form, Errors } from 'react-redux-form';
import { Helmet } from 'react-helmet';

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => val && (val.length >= len);
const isNumber = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

class Contact extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);        
    }

    handleSubmit(values) {
        console.log("Current State is: " + JSON.stringify(values));
        this.props.postFeedback(values);
        this.props.resetFeedbackForm();
    }

    render() {

        return(
            <div className="fonts contact-page-bg">
                <Helmet>
                <title>Contact Us</title>
                <meta
                    name="description"
                    content="contact, Ma'ashiyaat Economics Network"
                    />
            </Helmet>
            <div className="about-Jumbotron">
                    <div className="container">
                        <div className="row row-header">
                            <div className="col-12">
                                <br />
                                    {/* <ScrollAnimation animateIn='fadeIn' delay={300}> */}
                                        <h1 className='text-center'>Contact Us</h1>
                                    {/* </ScrollAnimation> */}
                            </div>
                        </div>
                    </div>
                </div>
            <div className="container">
                <div className="row">
                    <Breadcrumb className="breadCrumb">
                        <BreadcrumbItem><Link to='/home'>Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Contact Us</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3>Contact Us</h3>
                        <hr />
                    </div>
                </div>
                <div className="row row-content">
                    
                    <div className="col-12">
                    <h3>Location Information</h3>
                    </div>
                    <div className="col-12 col-sm-4 offset-sm-1">
                        <div data-aos="fade-right" data-aos-duration="1000">                   

                            <h2>  <span className="fa fa-map-marker fa-2x fa-lg"></span></h2>
                            <h5>Our Address</h5>
                            <address>
                            Maulana Mohammad Ali Jauhar Marg,<br />
                            Jamia Nagar, New Delhi-110025<br />
                            INDIA<br />
                            <i className="fa fa-phone"></i>: +91 9711004021<br />
                            <i className="fa fa-envelope"></i>: <a href="mailto:Maashiyaatjmi@gmail.com">Maashiyaatjmi@gmail.com</a>
                            </address>
                            </div>
                    </div>
                    <div className="col-12 col-sm-6 offset-sm-1">
                    
                    </div>
                    <div className="col-12 col-sm-11 offset-sm-1">
                        <div className="btn-group" role="group">
                            <div data-aos="flip-up" data-aos-duration="1500" data-aos-delay="500">                   
                                <a role="button" className="btn btn-call" href="tel:+919711004021"><i className="fa fa-phone"></i> Call</a>
                                <a role="button" className="btn btn-insta" href="Instagram.com/maashiyaat_"><i className="fa fa-instagram"></i> Instagram</a>
                                <a role="button" className="btn btn-mail" href="mailto:Maashiyaatjmi@gmail.com"><i className="fa fa-envelope-o"></i> Email</a>
                        </div>
                        </div>
                    </div>
                </div>
                </div>
                <div className="row row-content form-section">
                <div className="col-12">
                      <h2 className="text-center feedback-heading"><b>Send us your Feedback</b></h2>
                   </div>
                    <div className="col-12 col-md-9 form">
                    <Form model="feedback" onSubmit={(values) => this.handleSubmit(values)}>
                        <div data-aos="fade-right" data-aos-duration="1000">                   

                    

                            <Row className="form-group">
                                <Label htmlFor="firstname" md={2}></Label>
                                <Col md={10}>
                                {/* eslint-disable-next-line */}
                                    <Control.text model=".firstname" id="firstname" name="firstname"
                                        placeholder="First Name"
                                        className="form-control inpt"
                                        validators={{
                                            required, minLength: minLength(3), maxLength: maxLength(15)
                                        }}
                                         />
                                    <Errors
                                        className="text-danger"
                                        model=".firstname"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: ' Must be greater than 2 characters',
                                            maxLength: ' Must be 15 characters or less'
                                        }}
                                     />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Label htmlFor="lastname" md={2}></Label>
                                <Col md={10}>
                                {/* eslint-disable-next-line */}
                                    <Control.text model=".lastname" id="lastname" name="lastname"
                                        placeholder="Last Name"
                                        className="form-control inpt"
                                        validators={{
                                            required, minLength: minLength(3), maxLength: maxLength(15)
                                        }}
                                         />
                                    <Errors
                                        className="text-danger"
                                        model=".lastname"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: ' Must be greater than 2 characters',
                                            maxLength: ' Must be 15 characters or less'
                                        }}
                                     />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Label htmlFor="telnum" md={2}></Label>
                                <Col md={10}>
                                {/* eslint-disable-next-line */}
                                    <Control.text model=".telnum" id="telnum" name="telnum"
                                        placeholder="Phone Number"
                                        className="form-control inpt"
                                        validators={{
                                            required, minLength: minLength(3), maxLength: maxLength(15), isNumber
                                        }}
                                         />
                                    <Errors
                                        className="text-danger"
                                        model=".telnum"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: ' Must be greater than 2 numbers',
                                            maxLength: ' Must be 15 numbers or less',
                                            isNumber: ' Must be a number'
                                        }}
                                     />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Label htmlFor="email" md={2}></Label>
                                <Col md={10}>
                                {/* eslint-disable-next-line */}
                                    <Control.text model=".email" id="email" name="email"
                                        placeholder="Email"
                                        className="form-control inpt"
                                        validators={{
                                            required, validEmail
                                        }}
                                         />
                                    <Errors
                                        className="text-danger"
                                        model=".email"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            validEmail: ' Invalid Email Address'
                                        }}
                                     />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={{size: 6, offset: 2}}>
                                    <div className="form-check">
                                        <Label check>
                                        {/* eslint-disable-next-line */}
                                            <Control.checkbox model=".agree" name="agree"
                                                className="form-check-input"
                                                 /> {' '}
                                                <strong>Subscribe for Newsletter</strong>
                                        </Label>
                                    </div>
                                </Col>
                                <Col md={{size: 3, offset: 1}}>
                                {/* eslint-disable-next-line */}
                                    <Control.select model=".contactType" name="contactType"
                                        className="form-control inpt">
                                        <option>Phone</option>
                                        <option>Email</option>
                                    </Control.select>
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Label htmlFor="message" md={2}></Label>
                                <Col md={10}>
                                {/* eslint-disable-next-line */}
                                    <Control.textarea model=".message" id="message" name="message"
                                        rows="12"
                                        className="form-control inptMssg"
                                        placeholder="Message" />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={{size:10, offset: 2}}>
                                    <Button className="button btn-lg" type="submit" color="bg-primary">
                                    Send Feedback
                                    </Button>
                                </Col>
                            </Row>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;